import {EventEmitter, Injectable} from '@angular/core';

@Injectable()
export class FormValidationService {
  public validateForm: EventEmitter<void> = new EventEmitter<void>();
}
